export const UrlUtils = () => {
  const urlEncode = (str: string | number | boolean): string => {
    try {
      return encodeURIComponent(str)
    } catch (e) {
      return String(str)
    }
  }

  return Object.freeze({
    urlEncode
  })
}

export type IUrlUtils = ReturnType<typeof UrlUtils>
